import { type JSX, useMemo } from "react";
import { IconButton, Schedule } from "@/common-ui";
import { useCallbackState } from "@/sdk";
import { useControlsStore } from "../controls.store";

export function ToggleCallbackPanelButton(): JSX.Element {
    const callbackState = useCallbackState();
    const hasCallback = !!callbackState;
    const { scheduleCallbackPanelOpen, openCallbackPanel, closeCallbackPanel } = useControlsStore();

    const canScheduleCallback: boolean = useMemo(
        () => scheduleCallbackPanelOpen && !hasCallback,
        [hasCallback, scheduleCallbackPanelOpen],
    );
    const isDisabled = hasCallback && !scheduleCallbackPanelOpen;
    const handleClick = scheduleCallbackPanelOpen ? closeCallbackPanel : openCallbackPanel;

    return (
        <IconButton
            active={canScheduleCallback}
            analytics={{
                actionId: "ScheduleCallbackButton",
            }}
            aria-label="Schedule callback"
            data-testid="call-controls-callback-schedule-begin"
            disabled={isDisabled}
            onClick={handleClick}
            radius="xl"
            size="30"
            tooltip="Schedule callback"
        >
            <Schedule
                height={15}
                stroke={canScheduleCallback ? "var(--mantine-color-black)" : "var(--mantine-color-white)"}
            />
        </IconButton>
    );
}
